//Unicode constant declarations
const tickMark = '\u2714';

export {tickMark};